<template>
  <div class="gjzs">
    <div style="width:100%">   
    </div>
    <div class="Company_box">
      <p class="Company_text">股价走势</p>
      <div class="arrow-right">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }"
            >你现在所在的位置</el-breadcrumb-item
          >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>股价走势</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
   
    <div class="stock_img">
  
      <v-PieChart/>
    </div>
   
  </div>
</template>
<script>
import echarts from "echarts";
import vPieChart from "@/components/haed/pieChart.vue";

export default {
  data() {
    return {};
  },
  components: { vPieChart },
  mounted() {},
  methods: {
    drawLine() {
      // var i=0;
      // 基于准备好的dom，初始化echarts实例
      let myChart = this.$echarts.init(document.getElementById("myChart"));
      var color = ["#19D672", "#FD517D"];
      // 绘制图表
      myChart.setOption({
        color: ["#23D864", "#FF4D51"],

        // title: { text: '伦敦金' },

        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },

        legend: [
          {
            // orient: "vertical",
            itemWidth: 15,
            x: "2%",
            y: "20%",

            textStyle: {
              // color: '#ccc',
            },

            data: ["买跌"]
          },
          {
            itemWidth: 15,

            // orient: "vertical",
            x: "80%",
            y: "20%",
            data: ["买涨"]
          }
        ],
        series: [
          {
            name: "访问来源",
            type: "pie",
            data: ["20%", "80%"],
            radius: ["42%", "50%"],
            center: ["50%", "35%"],
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: false,
                position: "center"
              },

              emphasis: {
                show: true,
                textStyle: {
                  fontSize: "0",
                  fontWeight: "bold"
                }
              }
            },
            labelLine: {
              normal: {
                show: false
              }
            },

            itemStyle: {
              top: "50"

              // borderWidth: 50, //设置border的宽度有多大
            },

            data: [
              {
                value: this.percent1,
                name: "买跌",
                a: "1"
              },
              {
                value: this.percent2,
                name: "买涨",
                a: "1"
              }
            ]
          }
        ]
      });
    }
  }
};
</script>
<style scoped>
.arrow-right{
    text-align: center;
    margin-top: .2vw !important;
}
.el-breadcrumb{
  font-size: 0.9vw !important;
}
.Company_box{
  display: flex;
      width: 100%;
    height: 2vw;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    margin-top: 10px;
    border-bottom: 1px solid #dedede;
}
.Company_box {
  width: 95%;
}
.Company_box {
  margin-left: 40px;
}
.Pagination_box {
  margin-bottom: 4%;
}
.Company_text {
 font-weight: bold;
    font-size: 32px;
    color: #0c47a1;
    text-align: center;
    line-height: 2vw;
    /* margin-left: 10px; */
    margin-top: -0.5vw;
}
.stockName_box {
  display: flex;
  justify-content: space-between;
  width: 90%;
  height: 2vw;
  margin-top: 10px;
  font-size: 1.2vw;
  margin-left: 10px;
  margin-left: 40px;
}
.stock_name {
  font-size: 1vw;
  color: #0c47a1;
  line-height: 2vw;
}
.stock_right {
  width: 30%;
  height: 2vw;
  display: flex;
  justify-content: space-between;
  color: #0c47a1;
  font-size: 1vw;
  line-height: 2vw;
}
.Price {
  color: #f8072a;
}
.Falling {
  color: #12f90d;
}
.stock_img {
  width: 90%;
  height: 30vw;
  margin-left: 24px;
  margin-top: 16px;
}
.stock_img img {
  width: 100%;
  height: 100%;
}
.StockPage {
  width: 100%;
  /* height: 20vw; */
  margin-top: 5%;
}
.chart{
  width: 300px;
}
@media screen and (min-width: 320px) and (max-width: 750px) {
  .gjzs{
    width: 100%;
    height: 100%;
    margin-bottom: 2%;
  }
  .gjzs .Company_box{
    display: none;
  }
  .stock_img{
    height: 100%;
    margin-left: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/haed/stocks.vue